import {
  converge,
  find,
  pipe,
  nthArg,
  propEq,
  sortBy,
  compose,
  toLower,
  curry,
  filter,
  head,
  last,
  T,
  complement,
  update,
  __,
  findIndex,
  prop,
  map,
  isEmpty,
  symmetricDifference,
  join,
  split,
  omit,
  reject,
  either,
  path,
  addIndex,
} from "ramda"
import { isNotNilOrEmpty, propContainsCaseInsensitive } from "./string"

export const joinByComma = join(",")
export const splitByComma = split(",")

export const isFirst = curry((array, i) => i === head(array))
export const isLast = curry((array, i) => i === last(array))

export const isNotFirst = complement(isFirst)
export const isNotLast = complement(isLast)

export const findById = converge(find, [pipe(nthArg(0), propEq("id")), nthArg(1)])

export const sortByCaseInsensitive = (func = e => e) => sortBy(compose(toLower, func))

export const filterByPropEquals = curry((propName, filterValue, array) =>
  filter(filterValue ? propEq(propName, filterValue) : T, array),
)

export const filterByPropContainsCaseInsensitive = curry((propName, filterValue, array) =>
  filter(filterValue ? propContainsCaseInsensitive(propName, filterValue) : T)(array),
)

export const rejectInactive = reject(either(propEq("active", false), propEq("isActive", false)))

export const moveArrayItem = curry((delta, array, element) => {
  const clonedArray = array.slice()
  const index = clonedArray.indexOf(element)
  const newIndex = index + delta

  if (newIndex < 0 || newIndex === clonedArray.length) {
    //Already at the top or bottom.
    return clonedArray
  }

  const firstItem = clonedArray[index]
  clonedArray[index] = array[newIndex]
  clonedArray[newIndex] = firstItem

  return clonedArray
})

export const moveArrayItemUp = moveArrayItem(-1)
export const moveArrayItemDown = moveArrayItem(1)

export const updateByFieldName = curry((fieldName, item, arr) =>
  compose(update(__, item, arr), findIndex(propEq(fieldName, prop(fieldName, item))))(arr),
)

export const eqValues = compose(isEmpty, symmetricDifference)

export const updateByKey = (value = {}, list = [], key = "id") => {
  return map(e => (e[key] === value[key] ? value : e), list)
}

export const arrayToMapWithKey = (key, array, omitKey = false) =>
  array.reduce((acc, value) => {
    const _path = isNotNilOrEmpty(key) ? key.toString().split(".") : []
    const _value = path(_path, value)

    if (_value) {
      acc[_value] = omitKey ? omit([key], value) : value
    }

    return acc
  }, {})

export async function mapSeries(array, iterator, thisArg) {
  const length = array.length
  const cb = arguments.length > 2 ? iterator.bind(thisArg) : iterator
  const results = new Array(length)

  for (let i = 0; i < length; ++i) {
    results[i] = await cb(array[i], i, array)
  }

  return results
}

export const mapPropToLowerCase = (array, propName) => map(compose(toLower, prop(propName)), array)

export const mappedIndex = addIndex(map)
